<template>
  <div class="language-switchover">
    <div>{{ presentTime }}</div>
  </div>
</template>
<script>
import { parseTime } from '@/utils/datetime'

export default {
  name: 'TimeShow',
  data() {
    return {
      presentTime: '',
      timer: ''
    }
  },
  created() {
    this.refreshTime()
    this.timer = setInterval(this.refreshTime, 1000)
  },
  beforeDestroy: function() {
    clearInterval(this.timer)
  },
  methods: {
    refreshTime: function() {
      this.presentTime = new Date()
      this.presentTime = parseTime(this.presentTime, this.$t('timeshow.titleformat'), this.$t('timeshow.weekarray'))
    }
  }
}
</script>
<style scoped>
.language-switchover{
  display: inline-block;
  padding: 14px;
  color: white;
  margin-left: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/timeshow/index.vue